import { createCustomEnum } from "./customEnum";

const CommissionsSplitProfilesColumns = createCustomEnum({
	UserFriendlyId: {
		value: 0,
		name: "UserFriendlyId",
		displayName: "Id",
	},
	Name: {
		value: 1,
		name: "name",
		displayName: "Name",
	},
	Scenario: {
		value: 2,
		name: "scenario",
		displayName: "Scenario",
	},
	Status: {
		value: 3,
		name: "status",
		displayName: "Status",
	},
});
export default CommissionsSplitProfilesColumns;
